module.exports = __webpack_public_path__ + "img/yishi3.8034bb20.jpg";